import TimerBoldSvg from '@assets/images/svg/timer-bold.svg';
import React from 'react';

export interface TimerIconBoldProps {
    size?: number;
    color?: string;
}

export const TimerIconBold: React.FC<TimerIconBoldProps> = ({
    size = 24,
    color = '#333333',
}) => {
    return (
        <TimerBoldSvg width={size} height={size} color={color} />
    );
};

export default TimerIconBold;
